export default "__VITE_ASSET__4a7044ed__"